module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Regular.woff2
// module id = 62
// module chunks = 8